import React from 'react';
import Map, { MapProps, MapRef } from 'react-map-gl';

export type MapBoxRef = MapRef;

export interface IMapBoxProps extends MapProps {
    mapRef ?: React.RefCallback<MapBoxRef>;
}

const MapBox = (props : Omit<IMapBoxProps, 'transformRequest'>) => {
    const {
        mapRef,
        ...rest
    } = props;

    return (
        <Map
            {...rest}
            ref={mapRef}
            transformRequest={(url : string) => {
                if (!url.includes(GEO_SERVER_URL)) return { url };
                return {
                    url: `${url}&authkey=${process.env.GeoServerAccessToken}`,
                };
            }}
        />
    );
};

export default MapBox;


export interface MapBoxInitialState {
    longitude : number;
    latitude : number;
    zoom : number;
}